import { FunctionField } from "react-admin";
import Chip from "@mui/material/Chip";
import get from "lodash/get";

export const StringArrayField = ({ source, ...props }) => (
  <FunctionField
    source={source}
    {...props}
    render={(record) => {
      const values = get(record, source);

      if (!Array.isArray(values)) return null;

      return (
        <>
          {values.map((value, index) => (
            <Chip
              key={`${source}-${index}-${value}`}
              label={value}
              size="small"
              sx={{ mr: 0.5, mb: 0.5 }}
            />
          ))}
        </>
      );
    }}
  />
);
